import React from 'react';
import { useQuery } from '@apollo/client';
import { NCOM_PRODUCT_BY_ID, Product } from '../game-play/useGamePlay';
import { resizeImageUrl } from '../../../shared/CdnImages';
import NoCoverImage from '../../../assets/no-cover-vertical.svg';

type GameRecommendationEntryProps = {
    nsuid: string;
};

const GameRecommendationEntry = ({ nsuid }: GameRecommendationEntryProps) => {
    const { data: gameDetails, loading } = useQuery<
        { products: Product[] },
        { input: { nsuids: string[] } }
    >(NCOM_PRODUCT_BY_ID, {
        variables: {
            input: {
                nsuids: [nsuid.toString()],
            },
        },
    });

    const storeProduct =
        gameDetails?.products?.find((product: Product) =>
            product?.productImage?.publicId?.includes('store/'),
        ) || gameDetails?.products[0];

    const title = storeProduct?.name || (loading ? '' : 'Unavailable');
    const imageUrl = storeProduct?.productImage?.url || '';

    return (
        <div key={nsuid} className="game-recommendation-entry row no-gutters col-4 col-sm-12">
            <div className="image col-auto">
                <img src={imageUrl ? resizeImageUrl(imageUrl, 190) : NoCoverImage} alt={title} />
            </div>
            <div className="title col">{title}</div>
        </div>
    );
};

export default GameRecommendationEntry;
